import ReactDOM from "react-dom";
import React from "react";
import { useForm } from 'react-hook-form';
import { FilterSingleSelect, Button } from "@simpleview/sv-mosaic";
import SelectWrap from "./childComponents/SelectWrap";
import styled from 'styled-components';

import LinearProgress from '@material-ui/core/LinearProgress';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { H1, H3, BodyText, P } from "@simpleview/sv-mosaic";
import { theme } from "@simpleview/sv-mosaic";

const _ = require('lodash');


const StyledDiv = styled.div`
	position: relative;

	& form {
		font-family: ${theme.fontFamily};
		padding: 5px 10px;
	}
	& form h2 {
		font-family: ${theme.fontFamily};
		font-size: 20px;
		font-weight: 900;
	}
	& form .field-container { padding-bottom: 20px; }
	& form .error-message {
		visibility: hidden;
		width: auto;
		height: 0;
		-webkit-transition: border-color ease-in-out 0.3s, color ease-in-out 0.3s;
			transition: border-color ease-in-out 0.3s, color ease-in-out 0.3s;
	}
	& form div[data-validation="invalid"]:nth-of-type(2) {
		visibility: visible;
		height: auto;
		font-size: 11px;
		text-align: left;
		color: ${theme.colors.red};
	}
	& form input[type=submit] {
		background: #0070F2;
		border: none !important;
		border-radius: 4px;
		box-shadow: none;
		box-sizing: border-box;
		color: white;
		font-family: -apple-system,system-ui,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,Arial,sans-serif;
		font-size: 14px;
		font-weight: 500;
		letter-spacing: 0.02857em;
		line-height: 1.75;
		outline: none !important;
		padding: 6px 16px;
		transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
	}
	& form input[type=submit]:hover {
		background: rgba(0,89,191,1);
	}
	& form input[type=submit]:active {
		background: rgba(0,71,153,1);
	}
	& form .input-fields {
		display: block;
		position: relative;
		background-color: #fff;
		background-image: none;
		background-clip: padding-box;
		border-radius: .35rem;
		line-height: 2em;
		padding: 5px 10px;
		border: 1px solid ${theme.colors.gray300};
		-webkit-transition: color ease-in-out 0.3s, border-color ease-in-out 0.3s;
			transition: color ease-in-out 0.3s, border-color ease-in-out 0.3s;
	}
		& form .input-fields > label {
			position: absolute;
			top: -9px;
			left: 10px;
			background-color: #fff;
			font-size: 13px;
			font-weight: 300;
			color: ${theme.colors.gray300};
			line-height: 1;
			padding: 0 3px;
			-webkit-transition: color ease-in-out 0.3s, border-color ease-in-out 0.3s;
				transition: color ease-in-out 0.3s, border-color ease-in-out 0.3s;
		}
		& form .input-fields input,
		& form .input-fields textarea {
			display: block;
			width: 100%;
			padding: 0 10px;
			line-height: 40px;
			color: #000;
			border: 0 none;
			box-shadow: none;
			font-weight: 300;
			vertical-align: middle;
			outline-width: 0;
			outline: none;
		}

		& form .input-fields textarea{
			line-height: 1.5em;
			padding: 10px;
			min-height: 160px;
		}

		& form .input-fields:hover {
			box-shadow: none;
			border-color: ${theme.colors.gray400};
		}
		& form .input-fields:hover > label {
			color: ${theme.colors.gray400};
		}

		& form div.input-fields:focus-within {
			border-color: ${theme.colors.blue};
		}
		& form div.input-fields:focus-within > label {
			display: block;
			color: ${theme.colors.blue};
		}

		& form div[data-validation="invalid"]:nth-of-type(1) {
			border: 1px solid ${theme.colors.red} !important;
		}
		& form div[data-validation="invalid"] > label {
			display: block;
			color: ${theme.colors.red} !important;
		}

		& form .input-fields.disabled {
			border: 1px solid ${theme.colors.gray200} !important;
		}
		& form .input-fields.disabled > label {
			color: ${theme.colors.gray200} !important;
		}

		& form .input-fields input::active,
		& form .input-fields textarea::active { border: 0 none !important; }

		& form .input-fields .selectWrapper select {
			box-sizing: border-box;
			appearance: none;
			display: inline-block;
			outline: none;
			border: none;
			padding: 5px 11px;
			width: 100%;
			background: none;
			-webkit-transition: color ease-in-out 0.3s;
				transition: color ease-in-out 0.3s;
		}

		& form .input-fields .selectWrapper select[data-active="true"]{
			color: ${theme.colors.gray600};
		}

		& form .input-fields .selectWrapper select::-ms-expand {
			display: none;
		}

		& form .input-fields:focus .selectWrapper select,
		& form .input-fields:hover .selectWrapper select {
			color: ${theme.colors.gray600};
		}

		& form .input-fields .selectWrapper .expandIcon {
			position: absolute;
			top: 50%;
			top: calc(50% - 7.5px);
			right: 10px;
			pointer-events: none;
			color: ${theme.colors.gray600};
		}

		& form .input-fields.disabled .selectWrapper select,
		& form .input-fields.disabled .selectWrapper .expandIcon {
			color: ${theme.colors.gray200} !important;
		}

		& form .input-fields input::-webkit-input-placeholder,
		& form .input-fields textarea::-webkit-input-placeholder,
		& form .input-fields input::-moz-placeholder,
		& form .input-fields textarea::-moz-placeholder,
		& form .input-fields input:-ms-input-placeholder,
		& form .input-fields textarea:-ms-input-placeholder {
			color: ${theme.colors.gray400};
			opacity: 1;
		}

		& form .alert-success { padding: 1em; margin-top: 1em; }
		& form .alert-success p { margin: 0; }
		& form .alert-danger { padding: 1em; margin-top: 1em; }
		& form .alert-danger p { margin: 0; }
`;

const InputDiv = styled.div`
	& label {
		display: flex;
		font-weight: 300;
		line-height: 20px;
		margin: 8px 0;

		&.selected {
			color: ${theme.colors.gray600};
			font-weight: 500;
		}

		&:hover {
			color: ${theme.colors.gray600};
		}

		& input {
			-webkit-appearance: none;
			   -moz-appearance: none;
				-ms-appearance: none;
					appearance: none;
			margin-right: 16px;
			margin-top: 0px;
		}
	}
`;

const RadioDiv = styled(InputDiv)`
	& label input[type="radio"] {
		border: 2px solid ${theme.colors.gray400};
		border-radius: 10px;
		width: 20px;
		height: 20px;
		outline: none;
		padding: 3px;

		&:hover {
			border-color: ${theme.colors.gray600};
		}

		&:checked {
			background: ${theme.colors.blue};
			background-clip: content-box;
			border-color: ${theme.colors.blue};
		}
	}
`;

const CheckboxDiv = styled(InputDiv)`
	& label input[type="checkbox"] {
		border: 2px solid ${theme.colors.gray400};
		border-radius: 4px;
		width: 18px;
		height: 18px;
		outline: none;
		padding: 0px;
		position: relative;

		&:hover {
			border-color: ${theme.colors.gray600};
		}

		&:checked {
			background: ${theme.colors.blue};
			border-color: ${theme.colors.blue};
			&:after {
				position: absolute;
				content: "";
				left: 4px;
				top: 0px;
				width: 6px;
				height: 12px;
				border: solid white;
				border-width: 0 2px 2px 0;
				-webkit-transform: rotate(45deg);
					-ms-transform: rotate(45deg);
						transform: rotate(45deg);
			}
		}
	}
`;

const _buildForm = ({ register, handleSubmit, errors, onSubmit, data, sentState, formState, watch }) => {

	const sections = data.sections.map((section, index) => {
		return _buildSection({
			register,
			errors,
			data : section,
			index,
			watch
		});
	});

	const thisForm = this;

	const buttonArgs = {
		color : "blue",
		variant : "contained",
		label : "Submit",
		size : "medium",
		muiAttrs : {
			type : "submit"
		}
	}

	const { isSubmitting } = formState;

	return(
		<form onSubmit={handleSubmit(onSubmit)}>
			{
				data.title
				&& <h2>{data.title}</h2>
			}
			{
				data.details
				&& <P>{data.details}</P>
			}
			{sections}
			<div>
				{!isSubmitting &&
					<Button {...buttonArgs}/>
				}

				{isSubmitting &&
					<LinearProgress />
				}

				{(_.get(sentState,'sent') === true) &&
					<div className='alert-success'>
						<p>Your inquiry was sent.</p>
					</div>
				}

				{(_.get(sentState, 'error') === true) &&
					<div className='alert-danger'>
						<p>There was an issue when trying to send your inquiry.</p>
					</div>
				}
			</div>
		</form>
	);
};

const _buildSection = ({ register, errors, data, index, watch }) => {
	const fields = data.fields.map((field, index) => {
		return _buildField({
			register,
			errors,
			data : field,
			index,
			watch
		});
	});

	const key = `formSection-${index}`;

	return(
		<div key={key}>
			{
				data.title &&
				<H3>{data.title}</H3>
			}
			{
				data.details &&
				<P>{data.details}</P>
			}
			{fields}
		</div>
	);
};
//hold my beer
//https://stackoverflow.com/questions/16344583/style-select-element-based-on-selected-option
const _handleChange = (evt) => {
	evt.target.dataset.active = (evt.target.value !== "") ? "true" : "false";
}

const _buildField = ({register, errors, data, index, watch}) => {
	const validation = {
		required: (_.has(data, 'validation.required') === false) ? null : { value : data.validation.required, message : (data.validation.errors.required === undefined) ? `This field is required` : data.validation.errors.required },
		minLength : (_.has(data, 'validation.minLength') === false) ? null : { value : data.validation.minLength, message : (data.validation.errors.minLength === undefined) ? `This field must have at least ${validation.errors.minLength} character(s)` : data.validation.errors.minLength },
		maxLength : (_.has(data, 'validation.maxLength') === false) ? null : { value : data.validation.maxLength, message : (data.validation.errors.maxLength === undefined) ? `This field can have at most ${validation.errors.maxLength} character(s)` : data.validation.errors.maxLength },
	};

	if( _.has(data, "validation.customHandler") ){
		validation.validate = data.validation.customHandler;
	}

	const key = `formField-${data.name}-${index}`;
	const error = `${errors[data.name] ? 'invalid' : ''}`;

	let field = null;
	const fieldDisabled = (data.disabled && data.disabled === true) ? true : false;

	switch(data.type){
		case 'textarea':
			field = <textarea name={data.name} ref={ register(validation) } placeholder={data.placeholder} tabIndex="0" disabled={ fieldDisabled } />;
			break;
		case 'radio':
			const watchRadio = watch(data.name, false);
			const radioItems = data.options.map(option => {
				return (
					<RadioDiv key={ data.name+option.value }>
						<label className={watchRadio == option.value ? "selected" : ""}>
							<input type="radio" value={ option.value } name={ data.name } ref={ register(validation) }  />{ option.label }
						</label>
					</RadioDiv>
				);
			});
			field = <div>{ radioItems }</div>;
			break;
		case 'checkbox':
			const watchCheckbox = watch(data.name, []);
			const checkboxItems = data.options.map(option => {
				return (
					<CheckboxDiv key={ data.name + option.value }>
						<label className={watchCheckbox.includes(option.value) ? "selected" : ""}>
							<input type="checkbox" value={ option.value } name={ data.name } ref={ register(validation) } />{ option.label }
						</label>
					</CheckboxDiv>
				);
			});
			field = <div>{ checkboxItems }</div>;
			break;
		case 'select':
			const selectItems = data.options.map((option) => {
				return (
					<option value={ option.value } key={ option.value }>{ option.label }</option>
				);
			});

			if(data.unselected !== undefined) {
				selectItems.unshift(
					<option key={data.name + '_unselected'} value="">{ data.unselected }</option>
				);
			}

			field = <span className="selectWrapper">
					<ExpandMoreIcon className="expandIcon">More</ExpandMoreIcon>
					<select name={data.name} ref={register(validation)} onChange={ _handleChange } disabled={ fieldDisabled }>{selectItems}</select>
				</span>
			break;
		case "filterSingleSelect":
			field = <span className="selectWrapper">
					<SelectWrap
						name={data.name}
						options={data.options}
						label={data.label}
					/>
					<input name={data.name} ref={register(validation)} type="hidden" />
				</span>
			break;
		default:
			field = <input name={data.name} ref={ register(validation) } placeholder={data.placeholder} tabIndex="0" disabled={ fieldDisabled } />;
			break;
	}

	return(
		<div className="field-container" key={key}>
			<div className={`input-fields ${ ( fieldDisabled === true ) ? "disabled" : "" }`} data-validation={error}>
				{ field }
			</div>
			<div className="error-message" data-validation={error} >{errors[data.name]?.message}</div>
		</div>
	);
}

export default function DamForm(props) {
	let formArgs = {};
	if(props.config.defaultValues !== undefined ){
		formArgs = { defaultValues : props.config.defaultValues }
	}

	const {
		register,
		handleSubmit,
		errors,
		formState,
		watch
	} = useForm(formArgs);

	const onSubmit = props.config.onSubmit;
	const data = props.config;
	const sentState = props.sentState;

	return (
		<StyledDiv>
			{ _buildForm({ register, handleSubmit, errors, onSubmit, data, sentState, formState, watch }) }
		</StyledDiv>
	);
}